import { useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import { Select } from "components/base/Form";
import SearchBar from "components/base/SearchBar";
import Spinner from "components/base/Spinner";
import PageV2 from "components/shared/PageV2";
import { useSearchParams } from "react-router-dom";
import { FETCH_INC_ODOO_PRODUCTS } from "./graphql";
import OrdersViewContainer from "./OrdersViewContainer";

const IndexPage = () => {
  const { loading, error, data } = useQuery(FETCH_INC_ODOO_PRODUCTS);
  const [searchParams, setSearchParams] = useSearchParams({
    source: "markettime",
    q: "",
  });

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const params = Object.fromEntries([...searchParams]);

  return (
    <PageV2 title="Waboba INC Orders" index>
      <div className="flex flex-col h-full overflow-auto">
        <div className="flex items-center space-x-3">
          <Select
            value={params.source}
            onChange={(e) => {
              setSearchParams({ ...params, source: e.target.value });
            }}
          >
            <option value="markettime">Martket Time</option>
            <option value="sps">SPS Commerce</option>
          </Select>
          <div className="flex-1">
            <SearchBar
              placeholder="Search Orders by order number, customer name or sku."
              initialQuery={params.q}
              onChange={(nextQ) => setSearchParams({ ...params, q: nextQ })}
            />
          </div>
        </div>

        <div className="mt-4 relative card p-0 flex-1 overflow-auto">
          <OrdersViewContainer
            source={params.source}
            q={params.q}
            incOdooProducts={JSON.parse(data.odooProducts)}
          />
        </div>
      </div>
    </PageV2>
  );
};

export default IndexPage;
